import type { IOrganizationGeneralSettings } from '@common/validation/organization';
import type { ValidationErrors } from '@frontend/utils';
import { FormParagraphFormGroupField } from '@frontend/components/fields/FormParagraphField';
import { InputTextField } from '@frontend/components/userDataManagement/InputText';

type EditableFieldProps = {
    canEdit: boolean;
    errors: ValidationErrors;
    fieldKey: keyof IOrganizationGeneralSettings;
    isRequired?: boolean;
    label: string;
    maxLength?: number;
    tooltipText?: string;
};

export default function EditableTextField({
    canEdit,
    errors,
    fieldKey,
    isRequired,
    label,
    maxLength,
    tooltipText,
}: Readonly<EditableFieldProps>) {
    if (canEdit) {
        return (
            <InputTextField
                dontValidateOnBlur={true}
                error={errors.get(fieldKey)}
                fieldKey={fieldKey}
                hasErrors={errors.has(fieldKey)}
                isRequired={isRequired}
                label={label}
                maxLength={maxLength}
                nullable={!isRequired}
                tooltipText={tooltipText}
            />
        );
    }

    return (
        <FormParagraphFormGroupField
            fieldKey={fieldKey}
            label={label}
        />
    );
}
